module.exports = __webpack_public_path__ + "fonts/CeraPro-Medium.ee3e268.ttf";